export default "__VITE_PUBLIC_ASSET__9da9270c__"